import React from 'react';
import ComparisonMap, { PodMarker } from './ComparisonMap';
import gmapsIcon from '../../assets/maps/gmaps.svg';
import radarIcon from '../../assets/maps/radar.svg';
import uberIcon from '../../assets/maps/uber.svg';

type Coordinates = { lat: number; lng: number };

interface CoordinatesComparisonMapModalProps {
    show: boolean;
    onClose: () => void;
    fullAddress: string;
    traceId?: string;
    googleCoordinates?: Coordinates | null;
    radarCoordinates?: Coordinates | null;
    uberCoordinates?: Coordinates | null;
    deliveredCoordinates?: Coordinates | null;
    podMarkers?: PodMarker[];
}

const CoordinatesComparisonMapModal: React.FC<CoordinatesComparisonMapModalProps> = ({
    show,
    onClose,
    fullAddress,
    traceId,
    googleCoordinates,
    radarCoordinates,
    uberCoordinates,
    deliveredCoordinates,
    podMarkers
}) => {
    if (!show) return null;

    const hasPodMarkers = !!podMarkers && podMarkers.length > 0;

    return (
        <div
            className="modal fade show"
            style={{ display: 'block', backgroundColor: 'rgba(0,0,0,0.7)' }}
            tabIndex={-1}
            role="dialog"
            onClick={onClose}
        >
            <div
                className="modal-dialog modal-xl modal-dialog-centered"
                onClick={(e) => e.stopPropagation()}
                style={{ maxWidth: '90vw' }}
            >
                <div className="modal-content border-0 shadow-lg">
                    <div className="modal-header border-bottom flex-nowrap">
                        <h5 className="modal-title text-nowrap mb-0">
                            <i className="bi bi-map me-2"></i>Coordinates Comparison Map
                        </h5>
                        <div className="d-flex align-items-center gap-3 flex-wrap small ms-auto me-3">
                            {googleCoordinates && (
                                <span className="d-flex align-items-center gap-1">
                                    <img src={gmapsIcon} alt="Google" style={{ width: '16px', height: '16px' }} />
                                    {googleCoordinates.lat}, {googleCoordinates.lng}
                                </span>
                            )}
                            {radarCoordinates && (
                                <span className="d-flex align-items-center gap-1">
                                    <img src={radarIcon} alt="Radar" style={{ width: '16px', height: '16px' }} />
                                    {radarCoordinates.lat}, {radarCoordinates.lng}
                                </span>
                            )}
                            {uberCoordinates && (
                                <span className="d-flex align-items-center gap-1">
                                    <img src={uberIcon} alt="Uber" style={{ width: '16px', height: '16px' }} />
                                    {uberCoordinates.lat}, {uberCoordinates.lng}
                                </span>
                            )}
                            {hasPodMarkers ? (
                                <span className="d-flex align-items-center gap-1">
                                    <span style={{
                                        width: '12px',
                                        height: '12px',
                                        borderRadius: '50%',
                                        backgroundColor: '#6f42c1',
                                        display: 'inline-block'
                                    }}></span>
                                    PODs ({podMarkers!.length})
                                </span>
                            ) : deliveredCoordinates && (
                                <span className="d-flex align-items-center gap-1">
                                    <span style={{
                                        width: '12px',
                                        height: '12px',
                                        borderRadius: '50%',
                                        backgroundColor: '#6f42c1',
                                        display: 'inline-block'
                                    }}></span>
                                    {deliveredCoordinates.lat}, {deliveredCoordinates.lng}
                                </span>
                            )}
                        </div>
                        <button
                            type="button"
                            className="btn-close"
                            aria-label="Close"
                            onClick={onClose}
                        ></button>
                    </div>
                    <div className="modal-body p-0">
                        <ComparisonMap
                            googleCoordinates={googleCoordinates}
                            radarCoordinates={radarCoordinates}
                            uberCoordinates={uberCoordinates}
                            deliveredCoordinates={hasPodMarkers ? null : deliveredCoordinates}
                            podMarkers={podMarkers}
                            address={fullAddress}
                            traceId={traceId}
                            height="65vh"
                            zoom={19}
                            initialMapType="hybrid"
                            hideControls
                        />
                    </div>
                </div>
            </div>
        </div>
    );
};

export default CoordinatesComparisonMapModal;
